import {ToCompleteOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {NonEmptyString, StringUnion, isNonEmptyString, EmptyString} from 'Core/models/EmptyString';

export class UnvalidatedAWDLogin {
  public readonly key = 'UnvalidatedAWDLogin';

  constructor(public readonly username: StringUnion, public readonly password: StringUnion) {}
}

export class InvalidAWDLogin {
  public readonly key = 'InvalidAWDLogin';

  constructor(public readonly username: StringUnion, public readonly password: StringUnion) {}
}

export class ValidAWDLogin {
  public static create(username: StringUnion, password: StringUnion) {
    return isNonEmptyString(username) && isNonEmptyString(password)
      ? new ValidAWDLogin(username, password)
      : new InvalidAWDLogin(username, password);
  }

  public readonly key = 'ValidAWDLogin';
  private constructor(public readonly username: NonEmptyString, public readonly password: NonEmptyString) {}
}

export class ValidatingAWDLogin {
  public static create(login: ValidAWDLogin) {
    return new ValidatingAWDLogin(login.username, login.password);
  }

  public readonly key = 'ValidatingAWDLogin';
  private constructor(public readonly username: NonEmptyString, public readonly password: NonEmptyString) {}
}

export class UnsuccessfulAWDLogin {
  public static create(login: ValidatingAWDLogin) {
    return new UnsuccessfulAWDLogin(login.username, login.password);
  }

  public readonly key = 'UnsuccessfulAWDLogin';
  private constructor(public readonly username: NonEmptyString, public readonly password: NonEmptyString) {}
}

export type AWDLogin =
  | ValidAWDLogin
  | InvalidAWDLogin
  | UnvalidatedAWDLogin
  | UnsuccessfulAWDLogin
  | ValidatingAWDLogin;

export type AWDLoginOptions<TReturn> = ToCompleteOptions<AWDLogin, 'key', TReturn>;

export const matchAWDLogin = <TReturn>(awdLogin: AWDLogin, options: AWDLoginOptions<TReturn>): TReturn => {
  switch (awdLogin.key) {
    case 'InvalidAWDLogin':
      return options.InvalidAWDLogin ? options.InvalidAWDLogin(awdLogin) : (options as any).default(awdLogin);
    case 'UnvalidatedAWDLogin':
      return options.UnvalidatedAWDLogin ? options.UnvalidatedAWDLogin(awdLogin) : (options as any).default(awdLogin);
    case 'ValidAWDLogin':
      return options.ValidAWDLogin ? options.ValidAWDLogin(awdLogin) : (options as any).default(awdLogin);
    case 'ValidatingAWDLogin':
      return options.ValidatingAWDLogin ? options.ValidatingAWDLogin(awdLogin) : (options as any).default(awdLogin);
    case 'UnsuccessfulAWDLogin':
      return options.UnsuccessfulAWDLogin ? options.UnsuccessfulAWDLogin(awdLogin) : (options as any).default(awdLogin);
    default:
      return (options as any).default(awdLogin);
  }
};

export const changeUsername = (username: string) => (login: AWDLogin) =>
  ValidAWDLogin.create(NonEmptyString.create(username), login.password);
export const changePassword = (password: string) => (login: AWDLogin) =>
  ValidAWDLogin.create(login.username, NonEmptyString.create(password));

export const DefaultAWDLogin = new UnvalidatedAWDLogin(new EmptyString(), new EmptyString());
